import { Order } from '~hooks/useOrders/models';
import useMessagingUnreadCountSelectorQuery from '~queries/useMessagingUnreadCountSelectorQuery';

export default function useMessagingOrderUnreadCountQuery(
  order: Pick<Order, 'id' | 'messagingEnabled'>,
) {
  return useMessagingUnreadCountSelectorQuery(
    (unreadCounts) => unreadCounts.forOrder(order.id),
    { isEnabled: order.messagingEnabled },
  );
}
